import get from 'lodash/get';
import omit from 'lodash/omit';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useGetPatientsQuery} from '../../redux/services/patientApi';

import AppDashboard from '../AppDashboard';
import ListPatientsScreen from '../../components/patients/ListPatientsScreen';

const parseSearchParams = searchParams => {
  const allowedFields = ['patient_status', 'text', 'sort', 'id', 'patient__session_count'];
  const filters = allowedFields.reduce((acc, k) => {
    const val = searchParams.get(k);
    if (val) {
      if (val === null) return acc;
      if (val === 'true') return {...acc, [k]: true};
      if (val === 'false') return {...acc, [k]: false};
      return {...acc, [k]: val};
    }
    return acc;
  }, {sort: '-last_seen'});
  console.log('parseSearchParams', filters);
  return filters;
};

const handleFilter = ({setFilters, setSearchParams}) => filter => {
  console.log('handleFilter', filter);
  const parsedFilter = Object.keys(filter).reduce((acc, k) => {
    if (filter[k] == null) return acc;
    return {...acc, [k]: filter[k]};
  }, {});
  setSearchParams(parsedFilter || {});
  setFilters(parsedFilter || {});
};

const ListPatientsPage = props => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(parseSearchParams(searchParams));
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const providerQuery = useGetCurrentProviderQuery();
  const providerId = get(providerQuery, 'data.id');
  const patientsQuery = useGetPatientsQuery(
   {...filters, skip: pageIndex * pageSize, limit: pageSize},
    {skip: !providerId}
  );
  const unscheduledPatientsQuery = useGetPatientsQuery(
    {...filters, patient_status: 'Unscheduled', limit: pageSize},
    {skip: !providerId}
  );
  const scheduledPatientsQuery = useGetPatientsQuery(
    {...filters, patient_status: 'Scheduled', limit: pageSize},
    {skip: !providerId}
  );
  const goalsMePatientsQuery = useGetPatientsQuery(
      {...filters, patient_status: 'Goals Met', limit: pageSize},
      {skip: !providerId}
  );
  const referredOutPatientsQuery = useGetPatientsQuery(
      {...filters, patient_status: 'Referred Out', limit: pageSize},
      {skip: !providerId}
  );
  const lostPatientsQuery = useGetPatientsQuery(
      {...filters, patient_status: 'Lost', limit: pageSize},
      {skip: !providerId}
  );
  const allPatientsQuery = useGetPatientsQuery(
    omit({...filters, limit: pageSize}, 'patient_status'),
    {skip: !providerId}
  );
  const isLoading = providerQuery.isLoading || patientsQuery.isLoading;
  const childProps = {
    ...props,
    patients: (get(patientsQuery, 'data.data') || []),
    counts: {
      all: get(allPatientsQuery, 'data.count'),
      unscheduled: get(unscheduledPatientsQuery, 'data.count'),
      scheduled: get(scheduledPatientsQuery, 'data.count'),
      lost: get(lostPatientsQuery, 'data.count'),
      goalsMet: get(goalsMePatientsQuery, 'data.count'),
      referredOut: get(referredOutPatientsQuery, 'data.count'),
    },
    // Pagination
    pageIndex,
    pageSize,
    filters,
    setPageIndex,
    reload: () => patientsQuery.refetch(),
    count: get(patientsQuery, 'data.count') || 0,
    onFilterChange: handleFilter({setFilters, setSearchParams}),
    onPageChange: (e,num) => setPageIndex(num),
    onRowsPerPageChange: e => setPageSize(parseInt(e.target.value, 10)),
  };
  return (
    <AppDashboard title='Patients' loading={isLoading}>
      <ListPatientsScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListPatientsPage;
